import { Identifiable, CostProfile } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateCostProfile(httpClient: HttpClient) {
  return (
    costProfile: Identifiable<CostProfile>,
    nextCostProfile: CostProfile,
  ) =>
    httpClient.sendHttpRequest<Identifiable<CostProfile>>({
      endpoint: `/costProfiles/${costProfile.uuid}/update`,
      method: HttpMethods.PATCH,
      data: {
        name: nextCostProfile.name,
        ...(nextCostProfile.cost !== costProfile.cost && {
          cost: nextCostProfile.cost,
        }),
        description: nextCostProfile.description,
      },
    });
}

export { updateCostProfile };
